import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = { class: "w100" }
const _hoisted_3 = { class: "fl w100" }
const _hoisted_4 = { class: "fl w30 pad10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, "トップページにタグを固定する", -1)
const _hoisted_6 = { class: "mt30" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { class: "fl w65" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 0,
  class: "ml5 fl mr20"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "grey mt5",
  style: {"height":"10px"}
}, "|", -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = {
  key: 1,
  class: "SuggestsCalendarListContent ofs fl rad8 w98",
  style: {"height":"200px","box-shadow":"0 2px 4px rgba(0, 0, 0, 0.3)","border-top":"1px solid #ebebeb","border-bottom":"1px solid #ebebeb"}
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  class: "centered",
  style: {"margin-top":"50px"}
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "grey" }, "グループタグが見つかりませんでした。", -1)
const _hoisted_20 = ["src"]
const _hoisted_21 = { key: 2 }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  class: "ml5 fl mt6",
  style: {"width":"calc(100% - 48px)"}
}
const _hoisted_24 = { class: "fs13 mt1 mb1" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("hr", { style: {"border-bottom":"1px solid #ddd","top":"-12px"} }, null, -1)
const _hoisted_28 = { class: "w100" }
const _hoisted_29 = { class: "fl w100" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "header_title" }, "グループタグを追加", -1)
const _hoisted_31 = { class: "w100" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_35 = { class: "pad20" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("p", { class: "header_title" }, "作成済みのグループタグ", -1)
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = {
  class: "centered",
  style: {"margin-top":"50px"}
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", { class: "grey" }, "グループタグが見つかりませんでした。", -1)
const _hoisted_41 = ["src"]
const _hoisted_42 = { key: 2 }
const _hoisted_43 = {
  class: "hoverLgreyBg rad10 w100 pad10",
  style: {"height":"46px"}
}
const _hoisted_44 = {
  class: "ml5 fl mt6",
  style: {"width":"calc(100% - 48px)"}
}
const _hoisted_45 = {
  class: "fs13 mt1 mb1 fl",
  style: {"width":"300px"}
}
const _hoisted_46 = {
  class: "fl",
  style: {"width":"100px"}
}
const _hoisted_47 = {
  key: 0,
  class: "fs11 label dblueBg",
  style: {"width":"50px"}
}
const _hoisted_48 = {
  key: 1,
  class: "fs11",
  style: {"width":"50px"}
}
const _hoisted_49 = { class: "fs12 mt2 mb1 fl grey" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = ["onClick"]
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_55 = {
  key: 0,
  class: "llgreyBg mt20 rad10 pad10"
}
const _hoisted_56 = { class: "fl" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_58 = {
  class: /*#__PURE__*/_normalizeClass(`pad20 `)
}
const _hoisted_59 = {
  class: /*#__PURE__*/_normalizeClass(`mt10 fl mr40`)
}
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", {
  class: "fl mt5 mr30",
  style: {"width":"200px"}
}, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs13 fw600" }, "グループタグを固定表示 "),
  /*#__PURE__*/_createElementVNode("p", { class: "fs11 dgrey" }, "メンバー全員に固定でタブを表示します")
], -1)
const _hoisted_61 = { class: "fl" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChipButton = _resolveComponent("ChipButton")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_ListLoader = _resolveComponent("ListLoader")!
  const _component_TextfieldTag = _resolveComponent("TextfieldTag")!
  const _component_Switcher = _resolveComponent("Switcher")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", {
        class: _normalizeClass(`rad8 kakugo calendarfirst with_white_bg ofs ${_ctx.isSP ? 'pad20' : 'pad20'}`)
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("p", _hoisted_6, [
              _createTextVNode(" お気に入りの横にグループタグを表示できるようになります。"),
              _hoisted_7,
              _hoisted_8,
              _createElementVNode("button", {
                type: "submit",
                class: "pointer centered circle_button blueAround fs16 rad8 mt15 ml20",
                style: {"width":"120px","height":"50px","padding":"14px 8px"},
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateMyTabGroups && _ctx.updateMyTabGroups(...args)))
              }, " 保存 ")
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_ctx.myTabGroups)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.myTabGroups, (grTag, grtagindex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `${grtagindex}${grTag.systemUpdatedAt}${grTag.name}${_ctx.myTabGroups.length}`
                    }, [
                      _createVNode(_component_ChipButton, {
                        name: `${grTag.name}`,
                        returnVal: grTag,
                        onDelete: ($event: any) => (_ctx.deleteSelectGrtag(grTag)),
                        style: ``,
                        color: grTag.color,
                        class: "mr15 mb4 fl"
                      }, null, 8, ["name", "returnVal", "onDelete", "color"]),
                      (
                                        grTag.show_type == `pinned_all` &&
                                        _ctx.myTabGroups[grtagindex + 1] &&
                                        _ctx.myTabGroups[grtagindex + 1].show_type == `normal`
                                    )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_MdTextfieldTag, {
              placeholder: "グループタグ名を入力",
              style: `min-width: 270px;padding-top:0;min-height:inherit;margin:0`,
              class: "fl fs12 roundForm w100 searchField rad7",
              value: _ctx.searchText,
              onInputValue: _ctx.inputSearchText,
              onClickTextfield: _ctx.clickSearchField,
              onBlur: _ctx.blurSearchField
            }, null, 8, ["value", "onInputValue", "onClickTextfield", "onBlur"]),
            _hoisted_14,
            (_ctx.showSuggests)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  (!_ctx.searchedTags)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createVNode(_component_ListLoader)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.searchedTags.length == 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _hoisted_19,
                          _createElementVNode("img", {
                            src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
                            width: "30",
                            height: "30"
                          }, null, 8, _hoisted_20)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("ul", _hoisted_21, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchedTags, (grtag, grtagindex) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: `${grtagindex}${grtag.name}`,
                            style: {"height":"46px"},
                            class: _normalizeClass(`pointer w100 ofh posRe pad10`),
                            onClick: ($event: any) => (_ctx.selectGroupTag(grtag))
                          }, [
                            _createElementVNode("div", {
                              class: "fl rad6 mt9 mr2",
                              style: _normalizeStyle(`width: 12px; height: 12px;background-color:#${grtag.color}`)
                            }, "   ", 4),
                            _createElementVNode("div", _hoisted_23, [
                              _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_24, [
                                _createTextVNode(_toDisplayString(_ctx.truncate(grtag.name || ``, 20)), 1)
                              ])), [
                                [_directive_tooltip, grtag.name && grtag.name.length > 20 ? grtag.name : null]
                              ])
                            ]),
                            _hoisted_25
                          ], 8, _hoisted_22))
                        }), 128))
                      ]))
                ]))
              : _createCommentVNode("", true),
            _hoisted_26
          ])
        ])
      ], 2)
    ]),
    _hoisted_27,
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("section", {
        class: _normalizeClass(`rad8 kakugo calendarfirst with_white_bg ofs ${_ctx.isSP ? 'pad20' : 'pad20'}`)
      }, [
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", null, [
              _createVNode(_component_MdTextfieldTag, {
                name: "タグ名",
                style: {"height":"56px","min-width":"280px","max-width":"280px"},
                fieldStyle: "min-width:280px;",
                class: "fl fs14 mr20",
                value: _ctx.newTag.name,
                onInputValue: _ctx.inputTagName,
                required: ""
              }, null, 8, ["value", "onInputValue"]),
              _createVNode(_component_MdTextfieldTag, {
                name: "タグ説明",
                placeholder: "またはをつないだ公開ページに利用",
                style: {"height":"56px","min-width":"280px","max-width":"280px"},
                fieldStyle: "min-width:280px;",
                class: "fl fs14 mr20",
                value: _ctx.newTag.description,
                onInputValue: _ctx.inputDescription
              }, null, 8, ["value", "onInputValue"]),
              _createElementVNode("div", {
                class: "fl rad6 mt9 mr2",
                style: _normalizeStyle(`margin-top: 27px;width: 12px; height: 12px;background-color:#${_ctx.newTag.color}`)
              }, "   ", 4),
              _createVNode(_component_TextfieldTag, {
                name: "色",
                placeholder: "abcdef",
                style: {"height":"56px","min-width":"80px"},
                fieldStyle: "min-width:80px;",
                class: "fl fs14 mt4",
                maxLength: 6,
                value: _ctx.newTag.color,
                onInputValue: _ctx.inputColor
              }, null, 8, ["value", "onInputValue"]),
              _createElementVNode("button", {
                type: "submit",
                class: "pointer centered circle_button blueAround fs16 rad8 mt15 ml20",
                style: {"width":"120px","height":"50px","padding":"14px 8px"},
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addNewTag && _ctx.addNewTag(...args)))
              }, " 追加 "),
              _hoisted_32
            ])
          ]),
          _hoisted_33
        ]),
        _hoisted_34
      ], 2),
      _createElementVNode("section", _hoisted_35, [
        _hoisted_36,
        (!_ctx.groupTags)
          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
              _createVNode(_component_ListLoader)
            ]))
          : (_ctx.groupTags.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _hoisted_40,
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
                    width: "30",
                    height: "30"
                  }, null, 8, _hoisted_41)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_42, [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupTags, (grtag, grindex) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: `${grindex}${grtag.name}${grtag.description}${grtag.id}${grtag.show_type}${grtag.pinned_index_num}`,
                      class: _normalizeClass(`w100 posRe`)
                    }, [
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("div", {
                          class: "fl rad6 mt9 mr2",
                          style: _normalizeStyle(`width: 12px; height: 12px;background-color:#${grtag.color}`)
                        }, "   ", 4),
                        _createElementVNode("div", _hoisted_44, [
                          _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_45, [
                            _createTextVNode(_toDisplayString(_ctx.truncate(grtag.name || ``, 20)), 1)
                          ])), [
                            [_directive_tooltip, grtag.name && grtag.name.length > 20 ? grtag.name : null]
                          ]),
                          _createElementVNode("div", _hoisted_46, [
                            (grtag.show_type == `pinned_all`)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_47, " 固定: " + _toDisplayString(grtag.pinned_index_num), 1))
                              : (_openBlock(), _createElementBlock("div", _hoisted_48, " "))
                          ]),
                          _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_49, [
                            _createTextVNode(_toDisplayString(_ctx.truncate(grtag.description || ``, 20)), 1)
                          ])), [
                            [_directive_tooltip, grtag.description && grtag.description.length > 20 ? grtag.description : null]
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", {
                              class: "fs13 mt1 mb1 fr pointer skyblue",
                              onClick: ($event: any) => (_ctx.deleteGroupTag(grtag))
                            }, "削除", 8, _hoisted_50),
                            _createElementVNode("p", {
                              class: "fs13 mt1 mb1 fr mr20 pointer skyblue",
                              onClick: ($event: any) => (_ctx.editGroupTag(grtag))
                            }, "編集", 8, _hoisted_51)
                          ]),
                          _hoisted_52
                        ]),
                        _hoisted_53
                      ]),
                      _hoisted_54,
                      (_ctx.editTag && _ctx.editTag.id == grtag.id)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                            _createElementVNode("div", _hoisted_56, [
                              _createElementVNode("div", null, [
                                _createVNode(_component_MdTextfieldTag, {
                                  name: "タグ名",
                                  style: {"height":"56px","min-width":"280px","max-width":"280px"},
                                  fieldStyle: "min-width:280px;",
                                  class: "fl fs14 mr20",
                                  value: _ctx.editTag.name,
                                  onInputValue: _ctx.inputEditTagName,
                                  required: ""
                                }, null, 8, ["value", "onInputValue"]),
                                _createVNode(_component_MdTextfieldTag, {
                                  name: "タグ説明",
                                  placeholder: "またはをつないだ公開ページに利用",
                                  style: {"height":"56px","min-width":"280px","max-width":"280px"},
                                  fieldStyle: "min-width:280px;",
                                  class: "fl fs14 mr20",
                                  value: _ctx.editTag.description,
                                  onInputValue: _ctx.inputEditTagDescription
                                }, null, 8, ["value", "onInputValue"]),
                                _createElementVNode("div", {
                                  class: "fl rad6 mt9 mr2",
                                  style: _normalizeStyle(`margin-top:27px;width: 12px; height: 12px;background-color:#${_ctx.editTag.color}`)
                                }, "   ", 4),
                                _createVNode(_component_TextfieldTag, {
                                  name: "色",
                                  placeholder: "abcdef",
                                  style: {"height":"56px","min-width":"80px"},
                                  fieldStyle: "min-width:80px;",
                                  class: "fl fs14 mt4 llgreyBg",
                                  maxLength: 6,
                                  value: _ctx.editTag.color,
                                  onInputValue: _ctx.inputEditTagColor
                                }, null, 8, ["value", "onInputValue"])
                              ]),
                              _hoisted_57,
                              _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_58, [
                                  _createElementVNode("div", _hoisted_59, [
                                    _hoisted_60,
                                    _createVNode(_component_Switcher, {
                                      value: "type[show_type]",
                                      name: "グループタグを固定表示",
                                      checked: _ctx.editTag.show_type === 'pinned_all',
                                      display: "true",
                                      class: "checkUsingCal fl",
                                      onSelect: _ctx.changeShowType
                                    }, null, 8, ["checked", "onSelect"])
                                  ]),
                                  _createElementVNode("div", _hoisted_61, [
                                    (_ctx.editTag.show_type == `pinned_all`)
                                      ? (_openBlock(), _createBlock(_component_MdTextfieldTag, {
                                          key: 0,
                                          name: "グループタグの固定表示順位",
                                          fieldStyle: "min-width:180px;max-width:180px;",
                                          style: {"height":"56px","min-width":"180px"},
                                          class: "fl fs16",
                                          type: `number`,
                                          value: _ctx.editTag.pinned_index_num,
                                          onInputValue: _ctx.inputPinnedIndexNum
                                        }, null, 8, ["value", "onInputValue"]))
                                      : _createCommentVNode("", true),
                                    _hoisted_62
                                  ]),
                                  _hoisted_63
                                ])
                              ])
                            ]),
                            _createElementVNode("button", {
                              type: "submit",
                              class: "pointer centered circle_button blueAround fs16 rad8 mt15 ml20",
                              style: {"width":"120px","height":"50px","padding":"14px 8px"},
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.updateEditTag && _ctx.updateEditTag(...args)))
                            }, " 変更 "),
                            _createElementVNode("button", {
                              type: "submit",
                              class: "pointer centered circle_button blueAround fs16 rad8 mt15 ml20",
                              style: {"width":"120px","height":"50px","padding":"14px 8px"},
                              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancelEditTag && _ctx.cancelEditTag(...args)))
                            }, " キャンセル "),
                            _hoisted_64
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_65
                    ]))
                  }), 128))
                ])
              ]))
      ])
    ]),
    _hoisted_66
  ]))
}